module.exports = __webpack_public_path__ + "img/object-group.cc2876cb.svg";